export function isBase64Image(str) {
    if (!str) return false;
    
    try {
        // Extract base64 data (handle data URLs)
        const base64Data = str.includes(',') ? str.split(',')[1] : str;
        
        // Decode and check image signature
        const decoded = atob(base64Data);
        const bytes = new Uint8Array(decoded.slice(0, 4).split('').map(c => c.charCodeAt(0)));
        
        // Check common image signatures
        return (bytes[0] === 0xFF && bytes[1] === 0xD8) || // JPEG
               (bytes[0] === 0x89 && bytes[1] === 0x50) || // PNG  
               (bytes[0] === 0x47 && bytes[1] === 0x49) || // GIF
               (bytes[0] === 0x42 && bytes[1] === 0x4D);   // BMP
    } catch {
        return false;
    }
}